module.exports = __webpack_public_path__ + "static/media/doc-wrong.9a657e28.svg";